import { useSearchParams } from 'react-router-dom';
import { useListSavedQueries } from '@Inventory/services/savedQueryQueries';
import { ListFilterOption } from '@common/ui/ListFilters/common';
import GenericFilterSingleSelect from '@common/organisms/CommonFilters/GenericFilterSingleSelect';

export const SAVED_QUERY_QUERY_PARAM = 'access_scope_id';
export const SAVED_QUERY_LABEL = 'Saved Access Scope';
export const QUERY_QUERY_PARAM = 'query';

export default function SavedQueryFilter() {
  const { savedQueries, isFetching: isLoading } = useListSavedQueries();

  const options = savedQueries.map((savedQuery) => ({
    value: savedQuery.id,
    label: savedQuery.name,
    query: savedQuery.query,
  }));

  const [searchParams, setSearchParams] = useSearchParams();

  const handleOnSelect = (value: ListFilterOption) => {
    searchParams.set(SAVED_QUERY_QUERY_PARAM, value.value);
    if (value.query) {
      searchParams.set(QUERY_QUERY_PARAM, value.query);
    }
    setSearchParams(searchParams);
  };

  return (
    <GenericFilterSingleSelect
      options={options}
      filterLabel={SAVED_QUERY_LABEL}
      filterParam={SAVED_QUERY_QUERY_PARAM}
      isLoading={isLoading}
      handleSelect={handleOnSelect}
    />
  );
}
